export default "/assets/images/mila-feed-14-thumbnail.jpg?2888d681b9c82c1bbfb9d8692dae5ea7";